import { useEffect, useState } from 'react';

import { LOCAL_STORAGE } from '../constants/local-storage.constant';
import { getDividasTributarias } from '../operations/dividasTributarias';

// O menu remonta a cada página: guarda a resposta por empresa (token) para
// não buscar de novo a cada clique.
const cache: Record<string, number> = {};

/** Quantas pendências tributárias ativas a empresa logada tem, com ou sem valor. */
export const useDividasCount = () => {
  const token = localStorage.getItem(LOCAL_STORAGE.CUSTOMER_API_TOKEN) || '';
  const [count, setCount] = useState<number>(cache[token] || 0);

  useEffect(() => {
    if (!token) return undefined;
    if (token in cache) {
      setCount(cache[token]);
      return undefined;
    }

    let mounted = true;
    getDividasTributarias()
      .then((data) => {
        cache[token] = data.length;
        if (mounted) setCount(cache[token]);
      })
      .catch(() => {
        // Sem o ponto não quebra nada: o menu segue normal.
      });

    return () => {
      mounted = false;
    };
  }, [token]);

  return count;
};
